
import s from './Hero'
export default s
